module.exports = __webpack_public_path__ + "static/media/icon-internet-not-fast.fd928d2e.svg";